const validate = (values:any) => {
  const errors: {taskName:any;assignTo:any;todoType:any;lor:any;notes:any;documents:any;}=
  {taskName:undefined,assignTo:undefined,todoType:undefined,lor:undefined,notes:undefined,documents:undefined}
  if (!values.taskName) {
      errors.taskName = 'Required';
    }
  if (!values.assignTo) {
  errors.assignTo = 'Required';
  }
  if (!values.taskName) {
  errors.taskName = 'Required';
  }
  if (!values.todoType) {
  errors.todoType = 'Required';
  }
  if (!values.lor) {
      errors.lor = 'Required';
  }
  if (!values.notes) {
      errors.notes = 'Required';
  }
  // if (!values.documents) {
  //     errors.documents = 'Required';
  // }
  return errors;
}

export default validate;
